import React from 'react';
import PropTypes from 'prop-types';

export function TableData({ children, ...props }) {
  // styling for the ul, ol and p elements within this table cell
  // (we can't apply these styles directly because we are rendering HTML pulled from the Civic Data API)
  const descendentStyling =
    '[&_ul]:text-base [&_ul]:md:pl-5 [&_ul]:mb-3 [&_ul]:last:mb-0 [&_ol]:text-base [&_ol]:md:pl-5 [&_ol]:mb-3 [&_ol]:last:mb-0 [&_p]:text-base [&_p]:mb-3 [&_p]:last:mb-0';

  // styling for the first colum, which should appear as a large section header in mobile/stacked view
  const rowHeaderStyling = `first:mt-0 first:mb-7 md:first:mb-4 ${
    props.smallMobileHeader ? 'first:text-xl' : 'first:text-3xl'
  } md:first:text-base first:font-bold md:first:font-normal`;

  // when in mobile/stacked view, adds the column header as a label above each rendering of a piece of data
  const mobileDataHeader =
    'before:content-[attr(data-title)] before:font-bold before:block before:mb-2 md:before:content-[""] md:before:mb-0';

  return (
    <td
      className={`mt-4 block border-0 border-base-300 p-0 align-text-top md:mt-0 md:table-cell md:max-w-[150px] md:border md:px-5 md:py-4 ${mobileDataHeader} ${rowHeaderStyling} ${descendentStyling}`}
      {...props}
    >
      {children}
    </td>
  );
}

TableData.propTypes = {
  children: PropTypes.node,
  smallMobileHeader: PropTypes.bool,
};

TableData.defaultProps = {
  smallMobileHeader: false,
};

export function TableRow({ children, ...props }) {
  return (
    <tr
      className='block hyphens-none border-2 border-base-200 p-7 md:table-row md:border-0'
      {...props}
    >
      {children}
    </tr>
  );
}

TableRow.propTypes = {
  children: PropTypes.node,
};

export function TableHeader({ children, ...props }) {
  return (
    <th
      className='border-1 hyphens-none whitespace-normal border-secondary bg-secondary align-text-top text-base font-semibold text-secondary-content'
      {...props}
    >
      {children}
    </th>
  );
}

TableHeader.propTypes = {
  children: PropTypes.node,
};

function Table({ children, ...props }) {
  return (
    <table
      className='table table-zebra table-pin-rows table-lg mb-10 mt-10 block border-collapse break-words last:mb-0'
      {...props}
    >
      {children}
    </table>
  );
}

Table.propTypes = {
  children: PropTypes.node,
};

export default Table;
